<template>
    <Modal :title="$t('labels.currency')" size="xs" ref="modal">
        <div class="modal-body">
            <FieldSet :title="$t('labels.basic_information')">
                <FormGroup :label="$t('labels.name')">
                    <Input :model-value="currency.name" type="text" :disabled="true"/>
                </FormGroup>
                <FormGroup :label="$t('labels.rate')">
                    <Input v-model="rate" type="number"/>
                </FormGroup>
                <FormGroup :label="$t('labels.main_currency')">
                    <CheckBox v-model="main" :disabled="currency.main"/>
                </FormGroup>
            </FieldSet>
        </div>
        <div class="modal-footer">
            <Button size="sm" color="light" class="mr-2" :disabled="currency.main" @click="remove">
                {{ $t('buttons.delete') }}
            </Button>
            <Button size="sm" color="teal" @click="update">
                {{ $t('buttons.edit') }}
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from '../../../../../components/new/modal/AppModal.vue';
import FieldSet from '../../../../../components/new/AppFieldset.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import CheckBox from '../../../../../components/new/form/checkbox/AppCheckbox.vue';
import Button from '../../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../../services/HttpClient';
import MessageNotificator from '../../../../../services/MessageNotificator';

export default {
    name: "EditCurrencyModal",
    components: {
        Modal, FieldSet, FormGroup, Input, CheckBox, Button
    },
    emits: ['updated', 'deleted'],
    data() {
        return {
            currency: {
                id: null,
                name: '',
                main: false
            },
            rate: null,
            main: false
        }
    },
    methods: {
        show(currencyId) {
            httpClient.get('/settings/basic/currencies', {
                currency_id: currencyId
            }).then((response) => {
                let currency = response.data.data;

                this.currency = currency;
                this.rate = currency.rate;
                this.main = currency.main;
            });

            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
        },
        update() {
            httpClient.put('/settings/basic/currencies', {
                currency_id: this.currency.id,
                main: this.main,
                rate: this.rate
            }).then(() => {
                new MessageNotificator().success(this.$t('alerts.updated', {
                    model: this.$t('labels.currency')
                }));

                this.hide();
                this.$emit('updated');
            })
        },
        remove() {
            httpClient.delete('/settings/basic/currencies', {
                currency_id: this.currency.id
            }).then(() => {
                this.hide();
                this.$emit('deleted');
            })
        }
    }
}
</script>
